import { render } from "./petsProteenComponent.vue?vue&type=template&id=1c5ea1a0"
import script from "./petsProteenComponent.vue?vue&type=script&lang=js"
export * from "./petsProteenComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__